import { IMemberInfoResponse } from '@specialist/common/services/models/member-info.interface';
import { LiveChatMember } from '@specialist/common/services/models/live-chat-member.model';

export function tryStringify(item: unknown): string {
  try {
    return JSON.stringify(item);
  } catch (e) {
    console.error(e);
    return 'stringify error';
  }
}

const memberInfoResponseClass = class implements IMemberInfoResponse {
  MemberNumber = '';
  MemberFirstName = '';
  MemberLastName = '';
  MemberPhone = '';
  MemberEmail = '';
  MemberInfo = '';
};

export const sensitiveTypes: SensitiveType[] = [LiveChatMember, memberInfoResponseClass];

// List of sensitive field names that should be redacted in any object
export const sensitiveFieldNames: string[] = [
  'messageBody',
  'intent',
  'text',
  'texts',
  'FulfillmentMessages',
  'Message',
  'ast-message',
  'ccMessage',
];

export type SensitiveType = new () => unknown | Record<string, unknown> | { prototype: Record<string, unknown> };

export function removeSensitiveData<T>(item: T, sensitiveTypes: SensitiveType[]): T {
  if (item === null || typeof item !== 'object') {
    return item;
  }

  const copy = Array.isArray(item) ? item.slice() : { ...item };
  const sensitiveFields = new Set<string>(sensitiveFieldNames);

  // Collect the names of all fields that belong to sensitive types
  for (const type of sensitiveTypes) {
    const instance = typeof type === 'function' ? new type() : type;
    for (const field of Object.keys(instance)) {
      sensitiveFields.add(field);
    }
  }

  for (const key of Object.keys(copy)) {
    if (sensitiveFields.has(key)) {
      copy[key] = '[SENSITIVE DATA]';
    } else {
      copy[key] = removeSensitiveData(copy[key], sensitiveTypes);
    }
  }

  return copy as T;
}
